import React, { useState, useEffect } from 'react';
import {  Card, IconButton, Button, List, ListItem, ListItemAvatar, Avatar, ListItemText, ListItemSecondaryAction } from '@mui/material';
import { useSnackbar } from 'notistack';
import AddBoxIcon from '@mui/icons-material/AddBox';
import OndemandVideoRoundedIcon from '@mui/icons-material/OndemandVideoRounded';
import FileManagerDialog from './FileManagerDialog';
import {getMediaURL, truncate} from '../../../../config/values';
import {useTranslation} from "react-i18next";
import {X} from "lucide-react"
const MultipleFileChooser = ({ initial, onChange }) => {
    const [fileManagerPending, setFileManagerPending] = useState(false);
    const [images, setImages] = useState([]);
    const { enqueueSnackbar } = useSnackbar();
    const { t } = useTranslation();

    useEffect(() => {
        setImages(initial || []);
    }, [initial]);

    const toggleOperation = () => {
        setFileManagerPending((prev) => !prev);
    };

    const setImage = async (data) => {
        const updatedImages = [...images];
        updatedImages.push(data);

        if (updatedImages.length >= 9) {
            enqueueSnackbar( t('maxGallerySizeIs9'), { variant: 'warning' });
        }

        setImages(updatedImages);
        galleryChanges(updatedImages);
        toggleOperation();
    };

    const removeImage = (id) => {
        const updatedImages = images.filter((image) => image.id !== id);
        setImages(updatedImages);
        galleryChanges(updatedImages);
    };

    const galleryChanges = (updatedImages) => {
        onChange(updatedImages);
    };

    return (
        <>
            <List dense className="gallery">
                {images.length > 0 &&
                    images.map((row, key) => (
                        <ListItem key={key} className="gallery-item">
                            <ListItemAvatar>
                                <Avatar src={row.type === 'image' ? getMediaURL(row,'small') : null}>
                                    {row.type !== 'image' && <OndemandVideoRoundedIcon />}
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText
                                primary={truncate(row.name, 18)}
                                secondary={t(row.type)}
                            />
                            <ListItemSecondaryAction>
                                <IconButton
                                    size="small"
                                    onClick={() => removeImage(row.id)}
                                    aria-label={t('removeImage')}
                                >
                                    <X />
                                </IconButton>
                            </ListItemSecondaryAction>
                        </ListItem>
                    ))}
            </List>
            <Button
                onClick={toggleOperation}
                color="primary"
                size="small"
                startIcon={<AddBoxIcon />}
            >
                {t('addFile')}
            </Button>
            {fileManagerPending && (
                <FileManagerDialog
                    fileType="all"
                    selection
                    cancleOperation={toggleOperation}
                    setImage={setImage}
                />
            )}
        </>
    );
};

export default MultipleFileChooser;
